import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router";
import ModalHeader from "../../components/Header/ModalHeader";
import DialogComponent from "../../components/Dialog";
import TopicForm from "./TopicForm";
import { deleteTopic, getTopicFromServer } from "../../services/TopicService";
import addIcon from "../../assets/addWhiteIcon.png";
import updateIconImg from "../../assets/updateIconImg.png";
import deleteIconImg from "../../assets/deleteIcon.png";
import "./TopicModal.scss";
import { TokenDecrypt } from "../../utils/encryptionDecryption";

const TopicView = () => {
  const [filteredTopics, setFilteredTopics] = useState([]);
  const [filters, setFilters] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [editingTopic, setEditingTopic] = useState(null);
  const toast = useRef(null);
  const navigate = useNavigate();

  const fetchTopics = async (page, pageSize) => {
  try {
    const response = await getTopicFromServer(page, pageSize);
    const sorted = response.data.sort((a, b) => a.title.localeCompare(b.title));
    setFilteredTopics(sorted);
    setPage(response.page);
    setPageSize(response.pageSize);
    setTotalCount(response.total);
  } catch (err) {
    console.error("Error fetching topics:", err);
    setFilteredTopics([]);
    setTotalCount(0);
  }
};
  useEffect(() => {
  fetchTopics(page, pageSize);
}, [page, pageSize]);

  const onFilter = (e, field) => {
  const value = e.target.value.toLowerCase();
  const newFilters = { ...filters };
  newFilters[field] = value;
  setFilters(newFilters);
  };
  const searchTemplate = (field) => {
  const placeholderText = field.includes(".")
    ? `Search ${field
    .split(".")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")}`
    : `Search ${field}`;
  return (
    <InputText
      value={filters[field] || ""}
      onChange={(e) => onFilter(e, field)}
      placeholder={placeholderText}
      className="p-column-filter"
    />
  );
};
  const filteredData = filteredTopics.filter((item) =>
  Object.keys(filters).every((key) => {
    const keys = key.split(".");
    const value = keys.reduce((acc, k) => acc?.[k], item);
    return value?.toString().toLowerCase().includes(filters[key]);
  })
);

  const handleAddTopicClick = () => {
    setEditingTopic(null);
    setShowModal(true);
  };
  const handleUpdateTopicClick = () => {
    if (selectedTopics.length === 1) {
      setEditingTopic(selectedTopics[0]);
      setShowModal(true);
    }
  };
  const handleModalClose = () => {
    setShowModal(false);
    setEditingTopic(null);
    setSelectedTopics([]);
  };
const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  const handleDeleteTopics = async () => {
    if (selectedTopics.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one topic to delete.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: `Are you sure you want to delete the selected topic`,
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        let successCount = 0;
        let failedCount = 0;

        for (const topic of selectedTopics) {
          try {
            await deleteTopic(topic.id);
            successCount++;
          } catch (error) {
            console.error("Error deleting topic:", error.message);
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: error.message || "Failed to delete topic.",
              life: 5000,
            });
            failedCount++;
          }
        }
        if (successCount > 0) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: `Topic deleted successfully.`,
            life: 3000,
          });
        }
        setSelectedTopics([]);
        fetchTopics(page, pageSize);
      },
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="masterScreen">
                <div className="grid flex justify-content-end mb-4" style={{ marginLeft: '51rem'}}>
          <div className="sm:col-12 md:col-6 button_section">
                        <div className="flex justify-content-end align-items-center mt-4 mb-2 gap-18 w-full">
              <Button
                className="master-updateBtn"
                label="Update"
                icon={<img src={updateIconImg} alt="Update icon" />}
                tooltip="Update Topic"
                outlined
                disabled={selectedTopics.length !== 1}
                tooltipOptions={{ position: "bottom", event: "both" }}
                onClick={handleUpdateTopicClick}
              />
              <Button
                className="master-deleteBtn"
                label="Delete"
                severity="danger"
                icon={<img src={deleteIconImg} alt="Delete icon" />}
                outlined
                disabled={selectedTopics.length === 0}
                onClick={handleDeleteTopics}
              />
              <Button
                className="addBtn"
                label="Add New Topic"
                disabled={selectedTopics.length > 0}
                icon={<img src={addIcon} alt="Add icon" />}
                tooltip="Add New Topic"
                tooltipOptions={{ position: "bottom", event: "both" }}
                onClick={handleAddTopicClick}
              />
            </div>
          </div>
        </div>
        <DataTable
          lazy
          className="table-viewport custom-tooltip"
          resizableColumns
          value={filteredData}
          size="small"
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          rows={pageSize}
          first={(page - 1) * pageSize}
          rowsPerPageOptions={[5, 10, 20, 50]} 
          totalRecords={totalCount}
          onPage={(e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            const newPageSize = e.rows;
            handleTablePageChange(newPage, newPageSize);
          }}
          scrollable
          scrollHeight="510px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          selection={selectedTopics}
          onSelectionChange={(e) => setSelectedTopics(e.value)}
        >
          <Column
            selectionMode="multiple"
            header="Select"
            frozen
            alignFrozen="left"
          />
          <Column
            frozen
            alignFrozen="left"
            field="title"
            header="Topic Title"
            filter
            showFilterMenu={false}
            filterElement={() => searchTemplate("title")}
            style={{ cursor: "pointer" }}
          />
          <Column 
            frozen
            alignFrozen="left"
            field="Module.title"
            header="Module"
            filter
            showFilterMenu={false}
            filterElement={() => searchTemplate("Module.title")}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen
            alignFrozen="left"
            field="remarks"
            header="Remark"
            filter
            showFilterMenu={false}
            filterElement={() => searchTemplate("remarks")}
            style={{ cursor: "pointer" }}
          />
        </DataTable>
        <p className="text-sm">{totalCount} Total record</p>
        <DialogComponent
          visible={showModal}
          onHide={handleModalClose}
          header={
            <ModalHeader onClose={handleModalClose} backText="Back To Topic" />
          }
          style={{ width: "100vw", maxWidth: "1000px", height: "100vh" }}
        >
          <TopicForm topic={editingTopic} onClose={handleModalClose} />
        </DialogComponent>
        <ConfirmDialog />
      </div>
    </>
  );
};

export default TopicView;